export default __webpack_public_path__ + "static/media/sum.6d2252ba.svg";